import { api } from '@/shared/api/http'
import type { Entry, EntryDraft, EntryPage, Mood } from './types'

export interface ListEntriesParams {
  cursor?: string | null
  limit?: number
  signal?: AbortSignal
}

export function listEntries({
  cursor,
  limit = 20,
  signal,
}: ListEntriesParams = {}): Promise<EntryPage> {
  return api.get<EntryPage>('/entries', {
    query: { cursor: cursor ?? undefined, limit },
    ...(signal ? { signal } : {}),
  })
}

export function getEntry(id: string, signal?: AbortSignal): Promise<Entry> {
  return api.get<Entry>(`/entries/${id}`, signal ? { signal } : {})
}

export function createEntry(draft: EntryDraft): Promise<Entry> {
  return api.post<Entry>('/entries', draft)
}

/** 자동저장이 같은 기록을 반복 갱신한다. 서버가 멱등하게 처리한다. */
export function updateEntry(id: string, draft: EntryDraft): Promise<Entry> {
  return api.put<Entry>(`/entries/${id}`, draft)
}

export function deleteEntry(id: string): Promise<void> {
  return api.delete<void>(`/entries/${id}`)
}

export function listMoods(signal?: AbortSignal): Promise<Mood[]> {
  return api.get<Mood[]>('/moods', signal ? { signal } : {})
}
